import "@/App.css";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import ApartmentsSection from "@/components/ApartmentsSection";
import PricingSection from "@/components/PricingSection";
import DiscoverSection from "@/components/DiscoverSection";
import ReviewsSection from "@/components/ReviewsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <Navbar />
      <HeroSection />
      <ApartmentsSection />
      <PricingSection />
      <DiscoverSection />
      <ReviewsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
